import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import "./index.css";
import { RecoilRoot } from "recoil";
import { datadogRum } from "@datadog/browser-rum";
import App from "./App";
import { ProviderUniversalLoginProvider } from "./auth/providerUniversalLogin";
import { materialTheme, themePalette } from "./theme";

const shouldInitDatadogRum = import.meta.env.VITE_ENV !== "local";

if (shouldInitDatadogRum) {
  datadogRum.init({
    applicationId: "9d381794-1497-424e-b428-6ace962aec0c",
    clientToken: "pub0b92152e15fcce3f3b71e674634445a4",
    site: "datadoghq.com",
    service: "prenatal-provider-portal",
    env: import.meta.env.VITE_ENV,
    version: import.meta.env.VITE_DD_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask",
    allowedTracingUrls: [
      "https://api-staging.unityscreen.com",
      "https://api.unityscreen.com",
      "https://bto-patient-portal.herokuapp.com",
      "https://bto-prenatal-portal-staging.btoapps.com",
    ],
    traceSampleRate: 20,
    enableExperimentalFeatures: ["feature_flags"],
  });
}

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ProviderUniversalLoginProvider>
        <MuiThemeProvider theme={materialTheme}>
          <ThemeProvider theme={themePalette}>
            <App />
          </ThemeProvider>
        </MuiThemeProvider>
      </ProviderUniversalLoginProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root"),
);
